module.exports = __webpack_public_path__ + "img/slider1.f5abf72e.png";